import { Button } from "@chakra-ui/react"

const SubmitButton = ({ buttonText }) => {
    return (
        <Button
            colorScheme={"orange"}
            type='submit'
            w={{ base: "100%", sm: "auto" }}
            size={{ base: "sm", md: "md" }}
        >
            {buttonText}
        </Button>
    )
};

export default SubmitButton;